<template>
	<div>
		<div class="m-2 hidden-print">
			<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
			<div class="pull-right">
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{ $t('Печать')}}
				</b-button>
			</div>
		</div>
		<b-card class="m-2 p-3">
			<div v-for="item in priceWhItems" class="m-0 printPage" style="border: 2px solid #000; width: 30%; position: relative; height: 35mm; float: left; page-break-after: always; page-break-before: always; word-break:break-all;page-break-inside: avoid;">
				<h6 class="p-2 m-0" style="font-size: 12px"><strong>{{ item.barcode }}</strong> {{ item.itemName }}</h6>
				<h1 class="p-2 m-0" style="position: absolute; bottom: 0;left: 0;font-size: 4rem; font: bold"><strong>€ {{ item.priceUzs }}</strong></h1>
			</div>
		</b-card>
	</div>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: "PricePrint",
	computed: {
		...mapState('warehouse', ['priceWhItems']),
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
	},
	created() {
	}
}
</script>

<style scoped lang="scss">
* {
	box-sizing: border-box;
}
@media print {
	.hidden-print {
		display: none;
	}
	.card {
		box-shadow: none;
	}
	.printPage {
		page-break-after: always;
		word-break:break-all;
		page-break-inside: avoid;
		page-break-before: always;

	}
}

@page  {
	margin: 1cm;
}

</style>
